import { createSlice } from "@reduxjs/toolkit";

const initialState: IBenchNumberState = {
  data: null,
  totalCount: 0,
  showLoading: {
    sourceAction: "",
    state: false,
  },
  isLoading: false,
  isSuccess: false,
  Details: null,
};

export const benchNumberSlice = createSlice({
  name: "benchNumber",
  initialState,
  reducers: {
    setLoading: (state, action) => {
      const { sourceAction, isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: sourceAction,
        state: true,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    resetLoading: (state, action) => {
      const { isLoading, isSuccess } = action.payload;
      state.showLoading = {
        sourceAction: "",
        state: false,
      };
      state.isLoading = isLoading ? isLoading : false;
      state.isSuccess = isSuccess ? isSuccess : false;
    },
    replaceBenchNumber: (state, action) => {
      const { data, totalCount } = action.payload;
      state.data = data;
      state.totalCount = totalCount;
    },    
    setBenchNumberDetails: (state, action) => {
      state.Details = action.payload.data;
    },
  },
});

export const benchNumberActions = benchNumberSlice.actions;
export default benchNumberSlice.reducer;